import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/solid/image-fill.svg'
import _imports_1 from '@/assets/icons/solid/video-fill.svg'
import _imports_2 from '@/assets/icons/solid/participants-fill.svg'
import _imports_3 from '@/assets/icons/solid/variation-fill.svg'
import _imports_4 from '@/assets/icons/solid/option-fill.svg'
import _imports_5 from '@/assets/icons/solid/roles-fill.svg'


const _hoisted_1 = { class: "card" }
const _hoisted_2 = {
  key: 0,
  class: "h-60 w-full flex justify-center items-center"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "flex justify-center items-center object-cover h-60"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "grayed-icon h-10 w-10",
  src: _imports_0,
  alt: "image icon"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "px-3 pb-3 truncate w-full" }
const _hoisted_8 = { class: "truncate inline-block space-x-1 text-lg w-full" }
const _hoisted_9 = { class: "italic text-sm text-gray-500" }
const _hoisted_10 = { class: "flex justify-between items-center mt-3" }
const _hoisted_11 = { class: "flex justify-between items-center w-full" }

import { // api
		getSceneDetailsRolesByRecordId
	} from '../queries'

	import { // language
		useI18n
	} from 'vue-i18n'

	import { // store
		localesStore
	} from '@/store/locales'

	import {  
		store as _userStore
	} from '@/store/user'
	
	import { // vue
		computed,
		inject,
		onMounted,
		ref
	} from 'vue'

	import SceneDetails from './modals/scenes/SceneDetails.vue' // components
	import SceneVarRoles from './modals/scenes/variations/SceneVarRoles.vue'
	import SceneVarRolesList from './modals/scenes/variations/VarRolesInstructionsList.vue'
	import SceneVarRolesInstructions from './modals/scenes/variations/VarRoleInstructionsDetails.vue'
	import SceneOptionsTabs from './modals/scenes/options/SceneOptionsTabs.vue'
	import SceneOptionsRolesList from './modals/scenes/options/OptionRolesInstructionsList.vue'
	import SceneOptionsRolesInstructions from './modals/scenes/options/OptionRoleInstructionsDetails.vue'
	import SceneRolesList from './modals/scenes/roles/SceneRolesInstructionsList.vue'
	import SceneRolesInstructions from './modals/scenes/roles/SceneRoleInstructionsDetails.vue'
	import SceneSoundSongScores from './modals/scenes/soundDetails/SceneSoundSongScores.vue'
	import SceneSoundSongInstruments from './modals/scenes/soundDetails/SceneSoundSongInstruments.vue'
	import SceneSoundBGMSongs from './modals/scenes/soundDetails/SceneSoundBGMSongs.vue'
	import SceneSoundLiveScore from './modals/scenes/soundDetails/SceneSoundLiveScores.vue'
	import SceneSoundLiveSongs from './modals/scenes/soundDetails/SceneSoundLiveSongs.vue'
	import SceneSoundSongScoreFiles from './modals/scenes/soundDetails/SceneSoundSongScoresFiles.vue'
	import SceneSoundSongInstrumentFiles from './modals/scenes/soundDetails/SceneSoundSongInstrumentsFiles.vue'
	import SceneSoundLiveScoreFiles from './modals/scenes/soundDetails/SceneSoundLiveScoreFiles.vue'

	
	const __default__ = { name: 'SceneCard' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		scene: {
			type: Object,
			default: () => {return {}}
		},
		jobName: {
			type: String,
			default: ""
		}
	},
  setup(__props) {

	const props = __props

	const userStore = _userStore()
	const _localesStore = localesStore()

	const {t} = useI18n()

	const loading = ref(true)
	const s3: any = inject('s3')
	const signedUrl = ref('')
	const standardRoles = ref([])
	const musicianRoles = ref([])

	onMounted(async () => {
		// load scene roles for staff
		if(userStore.getContactType === 'Staff') {
			try { // fetching scene details	
				const recordId = props.scene.recordId			
				let res = await getSceneDetailsRolesByRecordId(recordId, "")
				const record = res.response.data[0]				
				standardRoles.value = record.portalData.standard_roles_staff
				musicianRoles.value = record.portalData.musician_roles_staff
			}
			catch(e) {
				console.error(e)
			}
		}
		// load image from s3
		try {
			const s3Json = JSON.parse(props.scene?.['job__job_scene__CONTACTS_SCENES__contactSceneID::s3JSONPicture'] || "{}")
			const key = s3Json?.thumbnail?.s3FilePathShortRaw
			
			if(key) {
				let params = {
					Bucket: process.env.VUE_APP_S3_BUCKET,
					Key: key
				}
	
				s3.getSignedUrlPromise('getObject', params).then(
					function (url: string) {
						signedUrl.value = url
					}, 
					function (err: Error) { 
						throw err
					}
				)
			}
		}
		catch(e) {
			console.log(e)
		}
		finally {
			loading.value = false
		}
	})

	const modalTitle = computed(() => {
		
		switch(currentModal.value) {
		case 'sceneDetails': 
			return selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display']
		case 'varRoleDetails':
			return currentDetails?.value?.['jobs_scenes__jobs_variations__VARIATIONS__variationID::name_display']
		case 'varRolesInstructionsList':
			return _localesStore.getLabel('181')
		case 'varRolesInstructions':
			return currentDetails?.value?.['jobs_variations_roles__instructions_join_jobs__INSTRUCTIONS__instructionID::name_display']
		case 'optionsTabs':
			return currentDetails?.value?.['jobs_scenes__jobs_scenes_options__SERVICES_OPTIONS__servicesOptionsID::name_display']
		case 'opRolesInstructionsList':
			return _localesStore.getLabel('181')
		case 'opRolesInstructions':
			return currentDetails?.value?.['jobs_scenes_options_roles__instructions_join_jobs__INSTRUCTIONS__instructionID::name_display']
		case 'scnRolesInstructionsList':
			return _localesStore.getLabel('181')
		case 'scnRolesInstructions':
			return currentDetails?.value?.['jobs_scenes_roles__instructions_join_jobs__INSTRUCTIONS__instructionID::name_display']
		case 'songScore':
			return _localesStore.getLabel('124')
		case 'songScoreFiles':
			return _localesStore.getLabel('575')
		case 'songScoreInstruments':
			return _localesStore.getLabel('287')
		case 'songInstrumentFiles':
			return 'Instrument Files'
		case 'bgmSong':
			return _localesStore.getLabel('182')
		case 'liveSong':
			return _localesStore.getLabel('182')
		case 'liveScore':
			return _localesStore.getLabel('124')
		case 'liveScoreFiles':
			return _localesStore.getLabel('575')	
		default: 
			return ''
		}
	})

	

	const sceneDetailsBreadcrumb = computed(() => {

		switch(currentModal.value) {
		case 'sceneDetails':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId}, hash: '#scenes' }}, // scenes
			]
		case 'varRoleDetails':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: _localesStore.getLabel('394'), to: "" }
			]
		case 'optionsTabs':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: _localesStore.getLabel('329'), to: "" }
			]
		case 'varRolesInstructionsList':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: _localesStore.getLabel('394'), to:"" }, // variations
				{label: _localesStore.getLabel('102'), to: "" }, // roles
				{label: currentDetails?.value?.['jobs_variations__jobs_variations_roles_musician__ROLES__roleID::name_display'] ||
					currentDetails?.value?.['jobs_variations__jobs_variations_roles_standard__ROLES__roleID::name_display'], to:""}  
			]
		case 'varRolesInstructions':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: _localesStore.getLabel('394'), to:""}, // variations
				{label: _localesStore.getLabel('102'), to:"" }, // roles
				{label: previousData?.value?.['jobs_variations__jobs_variations_roles_musician__ROLES__roleID::name_display'] ||
					previousData?.value?.['jobs_variations__jobs_variations_roles_standard__ROLES__roleID::name_display'], to:"" },
				{label: _localesStore.getLabel('181'), to:"" }, // Instructions  
			]
		case 'opRolesInstructionsList':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: _localesStore.getLabel('329'), to:"" }, // options
				{label: _localesStore.getLabel('102'), to:"" }, // roles
				{label: currentDetails?.value?.['jobs_scenes_options__jobs_scenes_options_roles__ROLES__roleID::name_display'], to:"" }  
			]
		case 'opRolesInstructions':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: _localesStore.getLabel('329'), to:"" }, // options
				{label: _localesStore.getLabel('102'), to:""}, // roles
				{label: previousData?.value?.['jobs_scenes_options__jobs_scenes_options_roles__ROLES__roleID::name_display'], to:""},
				{label: _localesStore.getLabel('181'), to:"" }
			]
		case 'scnRolesInstructionsList':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: _localesStore.getLabel('102'), to:"" }
			]
		case 'scnRolesInstructions':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: _localesStore.getLabel('102'), to:"" },
				{label: previousData?.value?.['jobs_scenes__jobs_scenes_roles_standard__ROLES_roleID::name_display'] ||
					previousData?.value?.['jobs_scenes__jobs_scenes_roles_musician__ROLES_roleID::name_display'], to:""},
				{label: _localesStore.getLabel('181'), to:""}
			]
		case 'songScore':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId}, hash: '#scenes' }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: _localesStore.getLabel('694'), to: ""}, 
				{label: currentDetails?.value?.['jobs_scenes__jobs_songs__SONGS__songsId::name_display'], to: ""},

			]
		case 'songScoreFiles':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId}, hash: '#scenes' }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: "...", to: ""}, 
				{label:  _localesStore.getLabel('124'), to: ""}, 
				{label: currentDetails?.value?.['jobs_songs__jobs_songs_scores__SCORES__scoreID::name_display'], to: ""},

			]
		case 'songScoreInstruments':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId}, hash: '#scenes' }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: "...", to: ""}, 
				{label:  _localesStore.getLabel('124'), to: ""}, 
				{label: currentDetails?.value?.['jobs_songs__jobs_songs_scores__SCORES__scoreID::name_display'], to: ""},
			]
		case 'songInstrumentFiles':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId}, hash: '#scenes' }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: "...", to: ""}, 
				{label:  _localesStore.getLabel('287'), to: ""}, 
				{label: currentDetails?.value?.['jobs_scongs_scores__instrument_jobs__ROLES__roleID::name_display'], to: ""},

			]
		case 'bgmSong':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId}, hash: '#scenes' }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: _localesStore.getLabel('694'), to: ""}, 
				{label: currentDetails?.value?.['jobs_scenes__jobs_bgms__BGMS__bgmID::name_display'], to: ""},

			]
		case 'liveSong':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId}, hash: '#scenes' }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: _localesStore.getLabel('694'), to: ""}, 
				{label: currentDetails?.value?.['jobs_scenes__jobs_live_ROLES__roleID::name_display'], to: ""}
			]
		case 'liveScore':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId}, hash: '#scenes' }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: _localesStore.getLabel('694'), to: ""}, 
				{label: previousData?.value?.['jobs_scenes__jobs_live_ROLES__roleID::name_display'], to: ""},
				{label:  _localesStore.getLabel('182'), to: ""},
				{label: currentDetails?.value?.['jobs_live__live_songs__SONGS__songID::name_display'], to: ""}, 
			]
		case 'liveScoreFiles':
			return [
				{label: t('nav.jobsMeetings'), to: {name: 'Jobs'}}, // Jobs & Meetings
				{label: props?.jobName, to: {name: 'JobDetails', params: {recordId: props?.job?.recordId} }},
				{label: _localesStore.getLabel('178'), to: {name: 'JobDetails', params: {recordId: props?.job?.recordId}, hash: '#scenes' }}, // scenes
				{label: selectedScene?.value?.['job__JOBS_SCENES__jobID::scene_number'] +  '. ' + selectedScene?.value?.['job__job_scene__SCENES__sceneID::name_display'], to: ""}, 
				{label: "...", to: ""}, 
				{label:  _localesStore.getLabel('124'), to: ""},
				{label: currentDetails?.value?.['live_songs__live_scores__SCORES__scoreID::name_display'], to: ""}, 
			]
		default: 
			return []
		}		
	})

	const selectedScene = ref({})
	const openToTab = ref(0)
	const sceneDetailsModal = ref<{open: boolean}>({open: false})
	const currentModal = ref("sceneDetails")
	const currentDetails = ref()
	const previousData = ref()
	const parentData = ref()
	const modalHistory = ref([])
	
	function showDetails(row: any, screen: string, tab: number, previous: any, direction: number = 0) {

		if(row != null) {
			if(!direction) {
				if(previous)modalHistory.value.push(previous)
				currentDetails.value = row
			}
			else {
				currentDetails.value = modalHistory.value.pop()
			}
		}
		currentModal.value = screen
		if(screen === 'varRoleDetails' || screen == 'optionsTabs' || screen == 'liveSong') {
			parentData.value = row
		}
		if(tab > 4 && userStore.getContactType != 'Staff') {
			openToTab.value = 4
		}
		else {
			openToTab.value = tab
		}
		if(previous != null) {
			previousData.value = previous
		}
	}

	function openModalDetails(row: any, tab: number) {
		selectedScene.value = row
		openToTab.value = tab
		sceneDetailsModal.value.open = true
		currentModal.value = "sceneDetails"
	}

	function modalClose() {
		sceneDetailsModal.value.open = false
	}

	const hasRoles = computed(() => {
		/**
		 * TODO - this is the part that doesn't work
		 */
		return standardRoles.value.length || musicianRoles.value.length
	})

return (_ctx: any,_cache: any) => {
  const _component_tw_loading = _resolveComponent("tw-loading")!
  const _component_ArrowRightIcon = _resolveComponent("ArrowRightIcon")!
  const _component_tw_modal = _resolveComponent("tw-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openModalDetails(__props.scene, 0))),
        class: "shadow-[inset_0_-3px_6px_rgba(95,77,63,0.16)] p-3 cursor-pointer"
      }, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_tw_loading)
            ]))
          : (signedUrl.value)
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: signedUrl.value,
                class: "h-60 w-full flex justify-center items-center object-cover"
              }, null, 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (openModalDetails(__props.scene, 0))),
          class: "flex justify-start items-center cursor-pointer"
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", null, _toDisplayString(props.scene['job__JOBS_SCENES__jobID::scene_number']) + ". ", 1),
            _createElementVNode("span", null, _toDisplayString(props.scene['job__job_scene__SCENES__sceneID::name_display']), 1)
          ]),
          _createVNode(_component_ArrowRightIcon, { class: "w-5 h-5" })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, _toDisplayString(props.scene['job__JOBS_SCENES__jobID::placement_display']), 1),
          _createElementVNode("div", {
            class: _normalizeClass({'link': props.scene['job__JOBS_SCENES__jobID::sound_choice_display_first']}),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openModalDetails(__props.scene, _unref(userStore).getContactType === 'Staff' ? 5 : 4)))
          }, _toDisplayString(props.scene['job__JOBS_SCENES__jobID::sound_choice_display_first'] || '—'), 3)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("img", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (openModalDetails(__props.scene, 0))),
              class: _normalizeClass(["h-6 w-6", [props.scene['job__job_scene__CONTACTS_SCENES__contactSceneID::s3JSONPicture'] ? 'linked-icon' : 'grayed-icon', 'cursor-pointer']]),
              src: _imports_0,
              alt: "image icon"
            }, null, 2),
            _createElementVNode("img", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (openModalDetails(__props.scene, 0))),
              class: _normalizeClass(["h-6 w-6", [props.scene['job__job_scene__CONTACTS_SCENES__contactSceneID::s3JSONVideo'] ? 'linked-icon' : 'grayed-icon', 'cursor-pointer']]),
              src: _imports_1,
              alt: "video icon"
            }, null, 2),
            _createElementVNode("img", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (openModalDetails(__props.scene, 1))),
              class: _normalizeClass(["h-6 w-6", [props.scene['job__job_scene__JOBS_PARTICIPANT__sceneID::_kp_jobs_participants_id'] ? 'linked-icon' : 'grayed-icon', 'cursor-pointer']]),
              src: _imports_2,
              alt: "video icon"
            }, null, 2),
            _createElementVNode("img", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (openModalDetails(__props.scene, 2))),
              class: _normalizeClass(["h-6 w-6", [props.scene['job__job_scene__JOBS_VARIATIONS__jobSceneID::_kp_jobs_variations_id'] ? 'linked-icon' : 'grayed-icon', 'cursor-pointer']]),
              src: _imports_3,
              alt: "variation icon"
            }, null, 2),
            _createElementVNode("img", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (openModalDetails(__props.scene, 3))),
              class: _normalizeClass(["h-6 w-6", [props.scene['job__job_scene__JOBS_SCENES_OPTIONS__jobSceneID::_kp_jobs_scenes_options_id'] ? 'linked-icon' : 'grayed-icon', 'cursor-pointer']]),
              src: _imports_4,
              alt: "option icon"
            }, null, 2),
            (_unref(userStore).getContactType === 'Staff')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (openModalDetails(__props.scene, 4))),
                  class: _normalizeClass(["h-6 w-6", [hasRoles.value ? 'linked-icon' : 'grayed-icon', 'cursor-pointer']]),
                  src: _imports_5,
                  alt: "roles icon"
                }, null, 2))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_tw_modal, {
      title: modalTitle.value,
      breadcrumb: sceneDetailsBreadcrumb.value,
      "close-modal": modalClose,
      ref_key: "sceneDetailsModal",
      ref: sceneDetailsModal
    }, {
      default: _withCtx(() => [
        (currentModal.value === 'sceneDetails')
          ? (_openBlock(), _createBlock(SceneDetails, {
              key: 0,
              scene: selectedScene.value,
              "show-details": showDetails,
              "open-to-tab": openToTab.value
            }, null, 8, ["scene", "open-to-tab"]))
          : (currentModal.value === 'varRoleDetails')
            ? (_openBlock(), _createBlock(SceneVarRoles, {
                key: 1,
                variation: currentDetails.value,
                "show-details": showDetails
              }, null, 8, ["variation"]))
            : (currentModal.value === 'varRolesInstructionsList')
              ? (_openBlock(), _createBlock(SceneVarRolesList, {
                  key: 2,
                  data: currentDetails.value,
                  previous: previousData.value,
                  parent: parentData.value,
                  "show-details": showDetails
                }, null, 8, ["data", "previous", "parent"]))
              : (currentModal.value === 'varRolesInstructions')
                ? (_openBlock(), _createBlock(SceneVarRolesInstructions, {
                    key: 3,
                    instruction: currentDetails.value,
                    previous: previousData.value,
                    "show-details": showDetails
                  }, null, 8, ["instruction", "previous"]))
                : (currentModal.value === 'optionsTabs')
                  ? (_openBlock(), _createBlock(SceneOptionsTabs, {
                      key: 4,
                      option: currentDetails.value,
                      "show-details": showDetails,
                      "open-to-tab": openToTab.value
                    }, null, 8, ["option", "open-to-tab"]))
                  : (currentModal.value === 'opRolesInstructionsList')
                    ? (_openBlock(), _createBlock(SceneOptionsRolesList, {
                        key: 5,
                        data: currentDetails.value,
                        previous: previousData.value,
                        parent: parentData.value,
                        "show-details": showDetails
                      }, null, 8, ["data", "previous", "parent"]))
                    : (currentModal.value === 'opRolesInstructions')
                      ? (_openBlock(), _createBlock(SceneOptionsRolesInstructions, {
                          key: 6,
                          instruction: currentDetails.value,
                          previous: previousData.value,
                          "show-details": showDetails
                        }, null, 8, ["instruction", "previous"]))
                      : (currentModal.value === 'scnRolesInstructionsList')
                        ? (_openBlock(), _createBlock(SceneRolesList, {
                            key: 7,
                            data: currentDetails.value,
                            previous: previousData.value,
                            parent: parentData.value,
                            "show-details": showDetails
                          }, null, 8, ["data", "previous", "parent"]))
                        : (currentModal.value === 'scnRolesInstructions')
                          ? (_openBlock(), _createBlock(SceneRolesInstructions, {
                              key: 8,
                              instruction: currentDetails.value,
                              previous: previousData.value,
                              "show-details": showDetails
                            }, null, 8, ["instruction", "previous"]))
                          : (currentModal.value === 'songScore')
                            ? (_openBlock(), _createBlock(SceneSoundSongScores, {
                                key: 9,
                                song: currentDetails.value,
                                "show-details": showDetails
                              }, null, 8, ["song"]))
                            : (currentModal.value === 'songScoreFiles')
                              ? (_openBlock(), _createBlock(SceneSoundSongScoreFiles, {
                                  key: 10,
                                  files: currentDetails.value,
                                  previous: previousData.value,
                                  "show-details": showDetails
                                }, null, 8, ["files", "previous"]))
                              : (currentModal.value === 'songScoreInstruments')
                                ? (_openBlock(), _createBlock(SceneSoundSongInstruments, {
                                    key: 11,
                                    song: currentDetails.value,
                                    previous: previousData.value,
                                    "show-details": showDetails
                                  }, null, 8, ["song", "previous"]))
                                : (currentModal.value === 'songInstrumentFiles')
                                  ? (_openBlock(), _createBlock(SceneSoundSongInstrumentFiles, {
                                      key: 12,
                                      files: currentDetails.value,
                                      previous: previousData.value,
                                      "show-details": showDetails
                                    }, null, 8, ["files", "previous"]))
                                  : (currentModal.value === 'bgmSong')
                                    ? (_openBlock(), _createBlock(SceneSoundBGMSongs, {
                                        key: 13,
                                        song: currentDetails.value,
                                        "show-details": showDetails
                                      }, null, 8, ["song"]))
                                    : (currentModal.value === 'liveSong')
                                      ? (_openBlock(), _createBlock(SceneSoundLiveSongs, {
                                          key: 14,
                                          song: currentDetails.value,
                                          "show-details": showDetails
                                        }, null, 8, ["song"]))
                                      : (currentModal.value === 'liveScore')
                                        ? (_openBlock(), _createBlock(SceneSoundLiveScore, {
                                            key: 15,
                                            song: currentDetails.value,
                                            previous: previousData.value,
                                            parent: parentData.value,
                                            "show-details": showDetails
                                          }, null, 8, ["song", "previous", "parent"]))
                                        : (currentModal.value === 'liveScoreFiles')
                                          ? (_openBlock(), _createBlock(SceneSoundLiveScoreFiles, {
                                              key: 16,
                                              files: currentDetails.value,
                                              previous: previousData.value,
                                              "show-details": showDetails
                                            }, null, 8, ["files", "previous"]))
                                          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title", "breadcrumb"])
  ], 64))
}
}

})